import { render, staticRenderFns } from "./areainspect.vue?vue&type=template&id=9761ec1a&"
import script from "./areainspect.vue?vue&type=script&lang=js&"
export * from "./areainspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports